__turbopack_context__.v({
  "arrowIcon": "ProductCollectionComponent-module-scss-module__3m_U3q__arrowIcon",
  "atEnd": "ProductCollectionComponent-module-scss-module__3m_U3q__atEnd",
  "buttonsContainer": "ProductCollectionComponent-module-scss-module__3m_U3q__buttonsContainer",
  "container": "ProductCollectionComponent-module-scss-module__3m_U3q__container",
  "footerLink": "ProductCollectionComponent-module-scss-module__3m_U3q__footerLink",
  "header": "ProductCollectionComponent-module-scss-module__3m_U3q__header",
  "headerLabel": "ProductCollectionComponent-module-scss-module__3m_U3q__headerLabel",
  "heading": "ProductCollectionComponent-module-scss-module__3m_U3q__heading",
  "label": "ProductCollectionComponent-module-scss-module__3m_U3q__label",
  "screenReaderOnly": "ProductCollectionComponent-module-scss-module__3m_U3q__screenReaderOnly",
  "swipeButtGreen": "ProductCollectionComponent-module-scss-module__3m_U3q__swipeButtGreen",
  "swipeButtHide": "ProductCollectionComponent-module-scss-module__3m_U3q__swipeButtHide",
  "swipeButtNext": "ProductCollectionComponent-module-scss-module__3m_U3q__swipeButtNext",
  "swipeButtPrev": "ProductCollectionComponent-module-scss-module__3m_U3q__swipeButtPrev",
  "swiper": "ProductCollectionComponent-module-scss-module__3m_U3q__swiper",
});
